import type { ProductVariantChannelAvailability } from "@commercetools/platform-sdk";
import type { ProductVariantAvailabilityStatus } from "@swo/shared";

export type PDPStockLevelIndicator =
  | {
      tag: "in-stock";
    }
  | {
      tag: "out-of-stock";
    }
  | {
      tag: "low-stock";
      count: number;
    }
  | {
      tag: "not-yet-available-for-sale";
      availableFrom: string;
    }
  | {
      tag: "preorder";
      availableFrom: string;
    }
  | {
      tag: "at-dealers-only";
    }
  | {
      tag: "discontinued";
    };

export function getPDPStockLevelIndicator2(
  availability: ProductVariantAvailabilityStatus | null,
): PDPStockLevelIndicator {
  if (!availability) {
    return { tag: "out-of-stock" };
  }

  switch (availability.tag) {
    case "not-yet-available-for-sale":
      return { tag: "not-yet-available-for-sale", availableFrom: availability.availableFrom };
    case "preorder":
      return { tag: "preorder", availableFrom: availability.availableFrom };
    case "in-stock":
      if (availability.availableQuantity <= 3) {
        return { tag: "low-stock", count: availability.availableQuantity };
      } else {
        return { tag: "in-stock" };
      }
    case "at-dealers-only":
      return { tag: "at-dealers-only" };
    case "out-of-stock":
      return { tag: "out-of-stock" };
    case "discontinued":
      return { tag: "discontinued" };
  }
}
